import { ClaimModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { nameOverrides } from './overrides';

const defaultClaim: ClaimModelDto = {
    claimId: 0,
    claimName: '',
    claimDescription: '',
};

export class Claim extends DomainEntity<ClaimModelDto> {
    constructor(data: ClaimModelDto) {
        super(data);
    }

    public get id() {
        return this.dto.claimId ?? 0;
    }

    public get name() {
        if (!this.dto.claimName) {
            return '';
        }

        return nameOverrides[this.dto.claimName] || this.dto.claimName;
    }

    public get description() {
        return this.dto.claimDescription;
    }

    public createDefault(): this {
        return new Claim(defaultClaim) as this;
    }
}
